(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blab-article"]) return;
  try {
    
(function(){
  var prose=document.querySelector('.blab-prose');
  var toc=document.querySelector('[data-toc]');
  if(!prose||!toc) return;
  var hs=prose.querySelectorAll('h2');
  if(!hs.length){return;}
  var list=toc.querySelector('.blab-toc-list');
  hs.forEach(function(h,i){
    if(!h.id){h.id='sec-'+(i+1)+'-'+(h.textContent||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'').slice(0,40);}
    var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;list.appendChild(a);
  });
  var faq=document.getElementById('blab-faq');
  if(faq){var a=document.createElement('a');a.href='#blab-faq';a.textContent='FAQ';list.appendChild(a);}
  toc.hidden=false;
  var links=[].slice.call(list.querySelectorAll('a'));
  var targets=links.map(function(l){return document.querySelector(l.getAttribute('href'));}).filter(Boolean);
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){links.forEach(function(l){l.classList.remove('on');});
      var idx=targets.indexOf(e.target);if(idx>-1)links[idx].classList.add('on');}});
    },{rootMargin:'-20% 0px -70% 0px'});
    targets.forEach(function(t){obs.observe(t);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // ✅ grab both logos
        this.logoDefault = this.header?.querySelector('.header-first-logo-icon'); // transparent/top
        this.logoSticky  = this.header?.querySelector('.header-second-logo-icon'); // after scroll
      // ✅ helper: show/hide right logo
      this.updateLogo = (pastHeader) => {
        if (!this.logoDefault || !this.logoSticky) return;
        this.logoDefault.classList.toggle('is-active', !pastHeader);
        this.logoSticky.classList.toggle('is-active', pastHeader);
        // optional a11y:
        this.logoDefault.setAttribute('aria-hidden', pastHeader ? 'true' : 'false');
        this.logoSticky.setAttribute('aria-hidden', pastHeader ? 'false' : 'true');
      };

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // ✅ set initial logo state on first paint & after full load
        const setInitialLogo = () => {
          const st = window.pageYOffset || document.documentElement.scrollTop;
          const past = st > (this.headerBounds?.bottom || 0);
          this.updateLogo(past);
        };
        requestAnimationFrame(setInitialLogo);
        window.addEventListener('load', setInitialLogo);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      
      const past = scrollTop > this.headerBounds.bottom;
      this.updateLogo(past);

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
